import apiRoutes from 'src/routes/apiRoutes';
import { emptyApi } from 'src/services/emptyApi';

export type SendCodeRequest = {
  phone: string;
};

export type SendCodeResponse = {
  detail: string;
};

export type VerifyCodeRequest = {
  phone: string;
  code: string;
};

export type VerifyCodeResponse = {
  detail: string;
};

export const phoneVerificationApi = emptyApi.injectEndpoints({
  endpoints: builder => ({
    sendCode: builder.mutation<SendCodeResponse, SendCodeRequest>({
      query: body => ({
        url: apiRoutes.phoneVerificationSendCode(),
        method: 'POST',
        body,
      }),
    }),
    verifyCode: builder.mutation<VerifyCodeResponse, VerifyCodeRequest>({
      query: body => ({
        url: apiRoutes.phoneVerificationVerifyCode(),
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSendCodeMutation, useVerifyCodeMutation } = phoneVerificationApi;
